import { styled } from "@mui/styles";

export const OurStoryWrapper = styled("div")(({ theme }) => ({
  margin: "160px auto 0",
  width: "80%",
  textAlign: "center",

  "@media (max-width:768px)": {
    margin: "90px auto 0",
  },
}));
